import { useEffect, useState } from 'react'
import { VALIDATION_ERROR } from '../../app/errors'
import { fullName, IsDateInFuture } from '../../app/utils'
import DateSelectionForm from '../DateSelectionForm'
import { ErrorWithString } from '../RegularComponents'

const OffenceDetailsForm = (props) => {

    const id = props.id + "-offence-history"
    const [offenderPeople, setOffenderPeople] = useState(props.people)
    const [dateOfOffence, setDateOfOffence] = useState(props.dateOfOffence)
    const [offenceDescription, setOffenceDescription] = useState(props.description)

    const [showValidationError,setShowValidationError] = useState(props.showValidationError)

    const [nameError,setNameError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [dateError, setDateError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [descriptionError, setDescriptionError] = useState(VALIDATION_ERROR.NO_ERROR)

    useEffect(() => { 

        const validateName = () => { 
            if(!offenderPeople || !offenderPeople.firstName) {
                setNameError(VALIDATION_ERROR.EMPTY)
            } else { 
                setNameError(VALIDATION_ERROR.NO_ERROR)
            }
        }

        const validateDate = () => { 
            if(!dateOfOffence || IsDateInFuture(dateOfOffence)) {
                setDateError(VALIDATION_ERROR.DATE_INVALID)
            } else { 
                setDateError(VALIDATION_ERROR.NO_ERROR)
            }
        }

        const validateDescription = () => { 
            if(!offenceDescription) {
                setDescriptionError(VALIDATION_ERROR.EMPTY)
            } else { 
                setDescriptionError(VALIDATION_ERROR.NO_ERROR)
            }
        }

        setOffenderPeople(props.people)
        setDateOfOffence(props.dateOfOffence)
        setOffenceDescription(props.description)
        setShowValidationError(props.showValidationError)

        if(props.showValidationError) {
            validateName()
            validateDate()
            validateDescription()
        }

    }, [
        props.people,
        props.dateOfOffence,
        props.description,
        props.showValidationError,
        offenderPeople,
        dateOfOffence,
        offenceDescription
    ])

    const isNameValid = () => { 
        if(showValidationError) { 
            return (nameError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isDateValid = () => { 
        if(showValidationError) { 
            return (dateError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isDescriptionValid = () => { 
        if(showValidationError) { 
            return (descriptionError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const offenderNameOptionElements = []

    if(props.peopleList) {
        offenderNameOptionElements.push(
            <option 
                key={"-1"} 
                value={"-1"}>
                {"Select"}
            </option>
        )
        
        props.peopleList.forEach((people) => {
            let nameC = []
            let name = fullName(people)
            if(name) { 
                nameC.push(name)
            }
            if(people.position) { 
                nameC.push(people.position)
            }

            offenderNameOptionElements.push(
                <option 
                    key={people.entityId} 
                    value={people.entityId}>
                    {nameC.join(', ')}
                </option>
            )
        })
    }

    return (
        <div className="ns-fieldset" id={id + "-form"}>
            {props.peopleList && 
                <div className={"ns-fieldset" + (!isNameValid() ? " ns-fieldset-message-error" : "")}>
                    <label
                        className="ns-label" 
                        id={id + "-offender-name-select-label"}
                        htmlFor={id + "-offender-name-select-input"}>
                            Name
                    </label>
                    {!isNameValid() && 
                    <span id={id + "-offender-name-select-error"} className="ns-error-message field-validation-error">
                        {ErrorWithString("Select a name from the list")}
                    </span>}
                    <div className="select fw-25 inlineDisplay">
                        <select
                            className={!isNameValid() ? "select--error" : ""}
                            style={{width : "25em"}}
                            id={id + "-offender-name-select-input"}
                            name={id + "-offender-name-select-input"}
                            value={offenderPeople ? offenderPeople.entityId : "-1"}
                            onChange={(e) => {
                                    if(e.target.value === "-1") { 
                                        setOffenderPeople(null)
                                    } else { 
                                        let people = props.peopleList.find((p) => (p.entityId && (p.entityId === e.target.value)))

                                        if(people) {
                                            //people
                                            setOffenderPeople(people)
    
                                            props.onDetailsChange({
                                                id: props.id,
                                                updatedDetails : {
                                                    people : people
                                                }
                                            })
                                        }
                                    }
                                }}>
                                {offenderNameOptionElements}
                        </select>
                    </div>
            </div>}
            <div className={"ns-fieldset" + (!isDateValid() ? " ns-fieldset-message-error" : "")}>
                <label
                    className="ns-label" 
                    id={id + "-offence-date-label"}>
                        Date of offence
                </label>
                <DateSelectionForm 
                    id={id + "-offence-date"} 
                    date={dateOfOffence}
                    showValidationError={showValidationError}
                    disableFutureDate={true}
                    onDateChange={(date) => {
                            setDateOfOffence(date)
                            
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    dateOfOffence : date
                                }
                            })
                        }} 
                />
            </div>
            <div className={"ns-fieldset" + (!isDescriptionValid() ? " ns-fieldset-message-error" : "")}>
                <label
                    className="ns-label" 
                    id={id + "-offence-description-label"}>
                        Offence description
                </label>
                <div className="help-block">
                    Maximum of 500 characters
                </div>
                {!isDescriptionValid() && 
                <span id={id + "-offence-description-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString("Enter a description of the offence")}
                </span>}
                <div className={"textarea fw-25 inlineDisplay"}>
                    <textarea
                        className={!isDescriptionValid() ? "ns-input--error" : ""}
                        style={{width: "25em"}}
                        id={id + "-offence-description-input"}
                        rows={4} 
                        cols={60}
                        maxLength={500}
                        value={offenceDescription || ""}
                        onInput={(e) => {
                            setOffenceDescription(e.target.value)
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    description : e.target.value
                                }
                            })
                        }}>
                    </textarea>
                </div> 
            </div>
        </div>
    )
}

export default OffenceDetailsForm